import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getSubscriptionSearchParams } from '../../../../../../extractFromState';
import {
  getIsCommonSubscriptionSystemInstalled,
  selectSelectedToolDomains,
  selectSubscriptionSystem,
} from '../../../../../../selectors/tools';
import { SearchPageSelect } from '../../../../../tools/SearchPage/Search.styles';
import { SUBSCRIPTION_SYSTEMS } from '../../../../../../constants/integrations';
import { COMMON_SUBSCRIPTION_EMAIL, SIMPLR_ORDER_SUBSCRIPTION_EMAIL } from '../../../../../../constants/searchActions';
import { setSearchType, setSubscriptionSystem } from '../../../../../../actions/tools/CommonSubscriptionActions';
import { showErrorMessage } from '../../../../../../util/errorPopupUtil';

const SearchOptions = () => {
  const dispatch = useDispatch();

  const searchParams = useSelector(getSubscriptionSearchParams);
  const subscriptionSystem = useSelector(selectSubscriptionSystem);
  const selectedToolDomains = useSelector(selectSelectedToolDomains);
  const isCommonSubscriptionSystemInstalled = useSelector(getIsCommonSubscriptionSystemInstalled);

  const getSimplrorderConfigsAllowCancelSubscription = useCallback(() => {
    const config = selectedToolDomains.simplrorderConfig || {};

    return Object.keys(config)
      .filter((key) => config[key].allowSubscriptionCancellation)
      .reduce((acc, key) => {
        acc[key] = config[key];

        return acc;
      }, {});
  }, [selectedToolDomains]);

  useEffect(() => {
    switch (subscriptionSystem) {
      case SUBSCRIPTION_SYSTEMS.SIMPLR_ORDER:
        dispatch(setSearchType(SIMPLR_ORDER_SUBSCRIPTION_EMAIL));

        return;
      case SUBSCRIPTION_SYSTEMS.COMMON:
        dispatch(setSearchType(COMMON_SUBSCRIPTION_EMAIL));

        return;
      default:
        showErrorMessage(`Sorry, subscription system ${subscriptionSystem} is not found.`);
    }
  }, [dispatch, subscriptionSystem]);

  useEffect(() => {
    const simplrorderConfigsAllowCancelSusbcription = Object.keys(getSimplrorderConfigsAllowCancelSubscription()) || [];
    // based on business requirements system supports only one system at a time
    if (!isEmpty(simplrorderConfigsAllowCancelSusbcription)) {
      dispatch(setSubscriptionSystem(SUBSCRIPTION_SYSTEMS.SIMPLR_ORDER));
    }
    if (isCommonSubscriptionSystemInstalled) {
      dispatch(setSubscriptionSystem(SUBSCRIPTION_SYSTEMS.COMMON));
    }
  }, [dispatch, getSimplrorderConfigsAllowCancelSubscription, isCommonSubscriptionSystemInstalled]);

  const handleChangeOption = async (e) => {
    dispatch(setSearchType(e.target.value));
  };

  return (
    <SearchPageSelect onChange={handleChangeOption} value={searchParams.searchType}>
      {subscriptionSystem === SUBSCRIPTION_SYSTEMS.SIMPLR_ORDER && (
        <>
          <option value={SIMPLR_ORDER_SUBSCRIPTION_EMAIL}>Get subscriptions by email</option>
        </>
      )}
      {subscriptionSystem === SUBSCRIPTION_SYSTEMS.COMMON && (
        <>
          <option value={COMMON_SUBSCRIPTION_EMAIL}>Get subscriptions by email</option>
        </>
      )}
    </SearchPageSelect>
  );
};

export default SearchOptions;
